import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { LottiePlayer } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import sparkleAnimation from './sparkle.json';
import styles from './SparkleIcon.module.scss';
export const GetSparkleIconTID = (parentTestId)=>getTestIds(parentTestId);
export const SparkleIcon = (param)=>{
    let { className, testId } = param;
    const { SparkleIconTestIds } = useMemo(()=>GetSparkleIconTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(LottiePlayer, {
        testId: testId || SparkleIconTestIds.Root(),
        animationData: sparkleAnimation,
        loop: true,
        autoplay: true,
        className: cn(styles.root, className)
    });
};
